<template>
  <li class="InvitedUser">
    <div class="InvitedUser-info w-2/3 md:w-3/5 mr-2 truncate">
      <span class="InvitedUser-email truncate">{{ invitation.email }}</span>
      <span class="InvitedUser-date truncate"
        >Invited {{ invitation.invitedAt | formattedDate }}</span
      >
    </div>
    <user-role
      :user-role="role"
      :manager-scope="managerScope"
      :actors="invitation.managedActors"
    />
    <lm-dropdown
      class="InvitedUser-menu"
      :items="options"
      auto-close
      @select="onSelect"
    />
  </li>
</template>

<script>
import LmDropdown from '@/components/ui/LmDropdown'
import UserRole from '@/components/ui/usersTable/UserRole'
import {Events, Modal, Roles} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'

export default {
  name: 'InvitedUserItem',
  components: {UserRole, LmDropdown},
  props: {
    invitation: {
      type: Object,
      required: true
    }
  },
  computed: {
    role() {
      return this.invitation.role.toLowerCase()
    },
    managerScope() {
      if (this.invitation.role === Roles.MANAGER) {
        return this.invitation.managedActors.length === 0 ? 'Global' : 'Scoped'
      }
      return false
    },
    options() {
      let t = []
      const role = this.invitation.role
      if (role === Roles.MANAGER) {
        t.push({action: 'manager', label: 'Change Manager scope'})
      }
      if (role !== Roles.MEMBER) {
        t.push({action: 'member', label: 'Set as Member'})
      }
      if (role !== Roles.MANAGER) {
        t.push({action: 'manager', label: 'Set as Manager'})
      }
      if (role !== Roles.ADMIN) {
        t.push({action: 'admin', label: 'Set as Admin'})
      }
      t.push({action: 'resend', label: 'Resend email'})
      t.push({action: 'revoke', label: 'Cancel invitation'})
      return t
    }
  },
  methods: {
    onSelect(item) {
      const r = item.action.toUpperCase()
      switch (r) {
        case Roles.MANAGER:
          this.openManagerModal()
          break
        case Roles.MEMBER:
        case Roles.ADMIN:
          this.setRole(item.action)
          break
        case 'REVOKE':
          this.revokeInvitation()
          break
        case 'RESEND':
          this.resendInvitation()
          break
      }
    },
    openManagerModal() {
      this.$store.commit('setCurrentInvitation', {...this.invitation})
      this.$router.pushQuery({
        submodal: Modal.MANAGER,
        email: this.invitation.email
      })
    },
    setRole(role) {
      this.$store
        .dispatch('setRole', {
          role,
          invitation: true,
          id: this.invitation.email
        })
        .then(() => {
          let msg = `${this.invitation.email} is now `
          msg += this.$options.filters.roleArticle(role)
          EventHub.emit(Events.SHOW_SNACKBAR, msg)
          this.$emit('updateRole', this.invitation.email, role.toUpperCase())
        })
        .catch(error => this.$emit('error', error))
    },
    revokeInvitation() {
      this.$store
        .dispatch('revokeInvitation', this.invitation.email)
        .then(() => {
          this.$emit('revoke', this.invitation.email)
        })
    },
    resendInvitation() {
      this.$store
        .dispatch('reinviteUser', this.invitation.email)
        .then(() => this.$emit('send', this.invitation.email))
        .catch(error => this.$emit('error', error))
    }
  }
}
</script>

<style>
.InvitedUser {
  display: flex;
  align-items: center;
  height: 80px;
  margin: 0 -24px 1px;
  padding: 0 24px;
  background-color: #f6f6f6;
  @media (--mobile) {
    margin: 0 -16px 1px;
    padding: 0 16px;
  }
  &-info {
    display: flex;
    flex-direction: column;
  }
  &-email {
    font-size: 15px;
    color: black;
  }
  &-date {
    margin-top: 4px;
    font-size: 13px;
    color: #969696;
  }
  &-menu {
    margin-left: auto;
  }
}
</style>
